import { Moment } from 'moment';
import { API_URI, apiGet } from './index';

const worldMap = {
    getCountrySummary: async (projectId: number, startDate: Moment, endDate: Moment, streamIds: number[]) => {
        const data = await apiGet(`${API_URI}/api/worldmap/countries?projectId=${projectId}&startDate=${startDate.format("DD MMM YYYY HH:mm:ss")}&endDate=${endDate.format("DD MMM YYYY HH:mm:ss")}&streamIds=${streamIds.join(',')}`)
        return data;
    },
    getClusters: async (projectId: number, startDate: Moment, endDate: Moment, streamIds: number[]) => {
        const data = await apiGet(`${API_URI}/api/worldmap/cluster?projectId=${projectId}&startDate=${startDate.format("DD MMM YYYY HH:mm:ss")}&endDate=${endDate.format("DD MMM YYYY HH:mm:ss")}&streamIds=${streamIds.join(',')}`)
        return data;
    }
}

export default worldMap;